import React from 'react';
import PropTypes from 'prop-types';
import { SVGIcon } from '@web/atoms';
import gladlyIcon from './gladly.svg';

export const ChatIcon = ({ fillColor = 'neutral.white' }) => {
  return (
    <SVGIcon
      icon={gladlyIcon}
      alt="Chat"
      width="24px"
      height="24px"
      viewBox="-2 -2 31 30"
      fillColor={fillColor}
    />
  );
};

ChatIcon.displayName = 'ChatIcon';

ChatIcon.propTypes = {
  fillColor: PropTypes.string,
};
